import "./Footer.css";
import { useNavigate } from "react-router-dom";
import logovanlight from "../../assets/Images/1logovanlight.png";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Divider line */}
      <div className="footer-divider"></div>

      <footer id="site-footer" className="footer-minimal">
        <div
          className="footer-logo-container"
          onClick={() => navigate("/")}
        >
          <img
            src={logovanlight}
            alt="logo"
            className="footer-logo-image"
          />
        </div>

        <div className="footer-links">
          <span
            className="footer-link"
            onClick={() => navigate("/about")}
          >
            Contact me
          </span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
